// src/admin/AuthProvider.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

const AuthCtx = createContext({ user: null, ready: false });
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
      setReady(true);
    });
    return unsub;
  }, []);

  return (
    <AuthCtx.Provider value={{ user, ready }}>
      {children}
    </AuthCtx.Provider>
  );
}

export default AuthProvider;
